// extracted by css-extract-rspack-plugin
export default {"RefSelectorPanels":"RefSelector-module__RefSelectorPanels__fPp_Q"};